import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const assignmentStatusesAdapter = getAdapter({ idFieldName: 'text' });

const assignmentStatusesSlice = createSlice({
  name: 'assignmentStatuses',
  initialState: assignmentStatusesAdapter.getInitialState(),
  reducers: {
    setAssignmentStatuses: (state, { payload: { assignmentStatuses } }) => {
      assignmentStatusesAdapter.setAll(state, assignmentStatuses);
    }
  }
});

const selectors = assignmentStatusesAdapter.getSelectors(({ assignmentStatuses }) => assignmentStatuses);

export const getAssignmentStatuses = state => selectors.selectAll(state);

export const { setAssignmentStatuses } = assignmentStatusesSlice.actions;

export default assignmentStatusesSlice.reducer;
